import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPenListIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={14}
    fill="none"
    viewBox="0 0 16 14"
    {...props}
  >
    <path
      fill="#000"
      d="M5.898 2.201 3.071 4.924c-.152.146-.342.25-.55.3l-1.085.26c-.174.043-.331-.109-.288-.276l.272-1.044c.052-.2.16-.383.311-.53L4.56.912zm.67-1.934c.37.356.37.933 0 1.29l-.335.322-1.34-1.29.336-.322a.973.973 0 0 1 1.34 0M7.987 3.661c0-.404.167-.732.374-.732H15.6c.207 0 .374.328.374.732 0 .405-.167.733-.374.733H8.361c-.207 0-.374-.328-.374-.733M0 8.465c0-.4.336-.722.75-.722h14.5c.414 0 .75.323.75.722a.736.736 0 0 1-.75.722H.75A.736.736 0 0 1 0 8.465M.75 12.556c-.414 0-.75.323-.75.722S.336 14 .75 14h14.5c.414 0 .75-.323.75-.722s-.336-.722-.75-.722z"
    />
  </svg>
);
export default SvgPenListIcon;
